export class FormDate {
  public year?: string;
  public month?: string;
  public day?: string;

  constructor(formDate: any) {
    this.year = formDate.year === undefined ? null : formDate.year;
    this.month = formDate.month === undefined ? null : formDate.month;
    this.day = formDate.day === undefined ? null : formDate.day;
  }

  getDate(): string | undefined {

    const year = this.year;
    const month = this.isValid(this.month) ? this.slice(this.month) : '';
    const day = this.isValid(this.day) ? this.slice(this.day) : '';

    if (year && month && day) {
      return `${year}-${month}-${day}`;
    } else if (year && month) {
      return `${year}-${month}`;
    } else if (year) {
      return year;
    }
  }

  getMonth(): string {
    return this.slice(this.month);
  }

  getDay(): string {
    return this.slice(this.day);
  }

  private slice(value): string {
    return ('0' + value.toString()).slice(-2);
  }

  isValidDay(): boolean {
    return this.isValid(this.day);
  }

  isValidMonth(): boolean {
    return this.isValid(this.month);
  }

  private isValid(value): boolean {
    if (value === undefined || value === null || value === '-1') {
      return false;
    }
    return true;
  }
}
